module.exports = __webpack_public_path__ + "static/media/tick-circle-white.88f8e003.svg";